export default "__VITE_ASSET__THr7NEUD__"